module.exports = __webpack_public_path__ + "img/RKS-front.f60bb698.jpg";